import React from 'react'
import SearchInput from 'components/SearchInput'
import { CompanyListDiv } from '../../../style'
import { Wrapper } from '../../../../JobRoles/PageHeader/JobRoleFilter/style'
import { BoldText } from '../../../../Placement/style'
import { Checkbox } from 'antd'

const RoleFilter = ({
  handleRolesCheckboxChange,
  selectedRoles,
  rolesDatas,
  roleSearchValue,
  setRoleSearchValue,
  handleRoleSearch,
}) => {
  const toTitleCase = str =>
    str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())

  return (
    <div>
      <CompanyListDiv>
        <Wrapper>
          <SearchInput
            width={'90%'}
            placeholder="Search for the company "
            bordered={true}
            searchValue={roleSearchValue}
            setSearchValue={setRoleSearchValue}
            handleCompanySearch={handleRoleSearch}
          />
        </Wrapper>

        {rolesDatas.map(role => {
          return (
            <Checkbox
              style={{ margin: '0px' }}
              key={role.id}
              onChange={() => handleRolesCheckboxChange(role.role_ids)}
              // checked={selectedRoles.includes(role.role_ids)}
              checked={selectedRoles
                .flat()
                .some(id => role.role_ids?.includes(id))}
            >
              {toTitleCase(role.title)}
            </Checkbox>
          )
        })}
      </CompanyListDiv>
    </div>
  )
}

export default RoleFilter
